var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-6 ml-6"},[_vm._v("Event data: "+_vm._s(_vm.eventdata))])
}
var staticRenderFns = []

export { render, staticRenderFns }